export enum PathEnum {
    // Base Path
    BASE_URL = '/',

    // Menu page
    MENU = 'menu',

    // Campaign review game
    REVIEW_GAME = 'review-game',

    // Errors
    ERROR = 'error',
    ERROR_MENU_404 = 'menu-404'

}